<template>
  <div class="panel granary-panel">
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
// import { getDpPagePanel } from "@/api/granary";
import { getDpDataItemByCode } from "@/api/granary";
import { loadCircleChart } from "../charts/circleChart";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["各区", "各行业"],
      active: 0
    };
  },
  mounted() {
    this.initDt();
    this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      if (this.circleData[this.active]) {
        loadCircleChart(
          this.circleChart,
          this.circleData[this.active],
          12,
          10,
          8
        );
      } else {
        this.initDt();
      }
      if (clearT) {
        this.startTimer();
      }
    },
    initDt() {
      this.circleChart = this.$echarts.init(this.$refs.chart);
      getDpDataItemByCode({ pagePanelCode: "nyczzb" }).then(res => {
        if (res) {
          let quList = res.slice(0, 5);
          let hyList = res.slice(5, res.length);

          const fontSizes = 12;
          const widths = 10;
          const itemGaps = 8;
          quList = quList.map(ele => {
            return {
              name: ele.item_name,
              value: Number(ele.value)
            };
          });
          hyList = hyList.map(ele => {
            return {
              name: ele.item_name,
              value: Number(ele.value)
            };
          });
          this.circleData = [quList, hyList];
          loadCircleChart(
            this.circleChart,
            this.circleData[this.active],
            fontSizes,
            widths,
            itemGaps
          );

          window.addEventListener("resize", () => {
            this.circleChart.resize();
          });
        }
      });
    }
    // dataLoad() {
    //   this.circleChart = this.$echarts.init(this.$refs.chart);

    //   // 各区种植面积占比
    //   const fontSizes = 12;
    //   const widths = 10;
    //   const itemGaps = 8;
    //   let circleData = [
    //     [
    //       {
    //         name: "茂南区",
    //         value: 575976
    //       },
    //       {
    //         name: "电白区",
    //         value: 2295791
    //       },
    //       {
    //         name: "信宜市",
    //         value: 1888973
    //       },
    //       {
    //         name: "高州市",
    //         value: 2420122
    //       },
    //       {
    //         name: "化州市",
    //         value: 1963498
    //       }
    //     ],
    //     [
    //       {
    //         name: "种植业",
    //         value: 4953413
    //       },
    //       {
    //         name: "林业",
    //         value: 557345
    //       },
    //       {
    //         name: "牧业",
    //         value: 2346071
    //       },
    //       {
    //         name: "渔业",
    //         value: 1032333
    //       },
    //       {
    //         name: "农林牧渔服务业",
    //         value: 255199
    //       }
    //     ]
    //   ];
    //   loadCircleChart(
    //     this.circleChart,
    //     circleData[this.active],
    //     fontSizes,
    //     widths,
    //     itemGaps
    //   );

    //   window.addEventListener("resize", () => {
    //     this.circleChart.resize();
    //   });
    // }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  position relative
  .tab-box
    position absolute
    top 10px
    right 4%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
  .chart
      height 100%
      width 100%
</style>
